import { Filter } from '@fabric-ui/components';

export enum PermissionSetType {
  Data = 'DATA',
  ResourceInstance = 'RESOURCE_INSTANCE',
  OLTPEntity = 'OLTP_ENTITY',
  ManualOverridePermission = 'MANUAL_OVERRIDE_PERMISSION',
}

export enum OLTPEntityResourceType {
  DashboardReport = 'DASHBOARD_REPORT',
}

export enum UserSharedType {
  Editor = 'EDITOR',
  Viewer = 'VIEWER',
}

export interface OLTPEntityResourceLink {
  resourceType: OLTPEntityResourceType;
  resourceId: string;
  sharedType: UserSharedType;
}

export interface OLTPEntityTagLink {
  tagId: string;
  tagName: string;
  sharedType: UserSharedType;
}

export interface OLTPEntityPermissionSetLinks {
  resources: OLTPEntityResourceLink[];
  tags: OLTPEntityTagLink[];
}

export interface OLTPEntityResourceLinkInput {
  resourceType: OLTPEntityResourceType;
  resourceId: string;
  sharedType: UserSharedType;
}

export interface OLTPEntityTagLinkInput {
  tagId: string;
  sharedType: UserSharedType;
}

export interface OLTPEntityLinksInput {
  resources: OLTPEntityResourceLinkInput[];
  tags: OLTPEntityTagLinkInput[];
}

export interface PermissionSetDto {
  id: string | null;
  name: string;
  type?: PermissionSetType | null;
  filter: Filter;
  accountId?: string | null;
  createdByUserId?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  updatedByUserId?: string | null;
}

export interface PermissionSetInput {
  id?: string | null;
  name: string;
  type?: PermissionSetType | null;
  filter: Filter;
  userIds?: string[] | null;
  /** Null = don't touch existing links. Empty lists = clear all. */
  permissionSetLinks?: OLTPEntityLinksInput | null;
}

export interface ContentPermissionUser {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
}

export interface PermissionSetResponse {
  permissionSet: PermissionSetDto;
  users: ContentPermissionUser[];
  permissionSetLinks?: OLTPEntityPermissionSetLinks | null;
}

export interface TaggedResource {
  resourceType: OLTPEntityResourceType;
  resourceId: string;
}

export interface TagPermissionSetLink {
  permissionSetId: string;
  permissionSetName: string;
  sharedType: UserSharedType;
}

export interface TagDto {
  id: string;
  name: string;
  resources: TaggedResource[];
  permissionSets: TagPermissionSetLink[];
}
